import React from 'react';
// Importing icons for various services
import networkIcon from '../assets/images/data-management.png';
import securityCameraIcon from '../assets/images/security-camera.png';
import posIcon from '../assets/images/terminal.png';
import digitalSignageIcon from '../assets/images/billboard.png';
import accessControlIcon from '../assets/images/call.png';
import alarmIcon from '../assets/images/alarm.png';
import visitCounterIcon from '../assets/images/visits.png';
import cablingIcon from '../assets/images/cable.png';
import lvCablingIcon from '../assets/images/voltage.png';
import voipIcon from '../assets/images/voip.png';
import circuitIcon from '../assets/images/extension.png';
import analogPhoneIcon from '../assets/images/analog-phone.png';
import wifiSiteSurveyIcon from '../assets/images/rb_2287.png';
import networkIcon2 from '../assets/images/service1.png';
// Expanded list of all services offered
const services = [
    { 
        icon: networkIcon2, 
        title: "Network Installation and Troubleshooting", 
        description: "Designing and deploying robust, high-performance wired and wireless networks tailored to your business needs." 
    },
    { 
        icon: posIcon, 
        title: "POS Installation and Troubleshooting", 
        description: "Expert installation and support for Point of Sale systems to ensure seamless and efficient transactions." 
    },
    { 
        icon: wifiSiteSurveyIcon, 
        title: "Wireless Site Surveys", 
        description: "Comprehensive site surveys to analyze RF environments and design optimal, interference-free wireless networks." 
    },
    { 
        icon: networkIcon, 
        title: "Wireless Installation and Troubleshooting", 
        description: "Professional installation and rapid troubleshooting for all types of wireless network infrastructures." 
    },
    { 
        icon: analogPhoneIcon, 
        title: "Analog Phone System Services", 
        description: "Installation, maintenance, and troubleshooting for traditional analog phone and POTS line systems." 
    },
    { 
        icon: voipIcon, 
        title: "VOIP Phone System Services", 
        description: "Full installation and support for modern Voice over IP (VoIP) phone systems for enhanced communication." 
    },
    { 
        icon: circuitIcon, 
        title: "Circuit Extensions", 
        description: "Extending T1, DSL, and other data circuits to new locations within your facility." 
    },
    { 
        icon: lvCablingIcon, 
        title: "Low Voltage Structured Cabling", 
        description: "Professional installation of Cat5, Cat6, and other low-voltage cabling for data and communication." 
    },
    { 
        icon: cablingIcon, 
        title: "Fiber Optic Cabling", 
        description: "High-speed fiber optic cable installation, splicing, and termination for maximum network performance." 
    },
    { 
        icon: securityCameraIcon, 
        title: "CCTV", 
        description: "Installation and configuration of Closed-Circuit Television systems for reliable video surveillance." 
    },
    { 
        icon: alarmIcon, 
        title: "Alarm Systems", 
        description: "Setup and maintenance of security alarm systems to protect your commercial or residential property." 
    },
    { 
        icon: visitCounterIcon, 
        title: "Traffic System Installation", 
        description: "Installation of traffic monitoring and control systems, including sensors and cameras." 
    },
    { 
        icon: digitalSignageIcon, 
        title: "Digital Signage", 
        description: "Installation and setup of digital displays and signage for advertising, information, and wayfinding." 
    },
    { 
        icon: accessControlIcon, 
        title: "Access Control Systems", 
        description: "Implementing keycard, biometric, and other access control systems to secure your premises." 
    },
];

const Services = () => {
  return (
    <section id="services" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6 text-center">
        <h3 className="text-base uppercase font-semibold text-blue-600">Our Services</h3>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 my-3">Our Wide Range of Technical Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mt-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center h-full">
              <img src={service.icon} alt={`${service.title} icon`} className="h-16 w-16 mb-4" />
              <h3 className="text-xl font-bold text-gray-800 mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;